class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.containerForm = this.querySelector('.drawer__multiaddress')
    this.buttonsModifyContainer = document.querySelector('.js-modify-addresses')
    /*this.modifyButtonAdresses = this.buttonsModifyContainer.querySelector('.js-modify-button')*/
    /*this.suppressButtonAdresses = this.buttonsModifyContainer.querySelector('.js-suppress-button')*/
    this.alreadyValidated = false;
    this.listenerButtonValidate = false;
    this.state = false;
    this.indexAddress = 0;
    this.maxIndexAddress = 0;
    this.translateX = 0;
    this.maxItemCount = 0;
    this.currentDate = new Date().toLocaleString('fr-FR', { day: 'numeric', month: 'long' })
    this.currentDate = this.currentDate.match(/^(\S+)\s(.*)/).slice(1)
    this.widthAddresses = 784;
    this.infoPopup = document.querySelector('.js-info-csv-popup')
    this.existingGiftLayer = false
    this.buttonsCancelMultiAddress = this.querySelectorAll('.js-button-cancel-multi-address')
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.querySelector('#csvfile').addEventListener('change', this.readCSV.bind(this));

    // quick add associated products
    const quickAddButtons = this.querySelectorAll('.button-add-product-cart')
    if (quickAddButtons.length > 0) {
      quickAddButtons.forEach(button => {
        button.addEventListener('click', async () => {
          var productToAdd = [{
            id: button.dataset.id,
            quantity: 1
          }]
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: productToAdd })
          })
              .then(response => response.json())
              .then(async response => {
                var cartData_product = response;
                await publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: button.dataset.id,
                  cartData: cartData_product
                });
                button.parentNode.remove()
              })
        });
      })
    }
    var panel = document.querySelector('.associated-products-pannel')
    var list = document.querySelector('.associated-products-list')
    if (list.innerHTML.trim() === '') {
      panel.style.opacity = 0
      setTimeout(() => {
        panel.classList.add('tw-hidden')
      }, 200)
    } else {
      panel.classList.remove('tw-hidden')
      setTimeout(() => {
        panel.style.opacity = 1
      }, 100)
    }

    if (window.location.pathname == '/cart' || window.location.pathname == '/en/cart') {
      this.open()
    }

    this.querySelector('.js-toggle-layer-gift')?.addEventListener('click', () => this.toggleGiftLayer())

    /*this.modifyButtonAdresses?.addEventListener('click', () => {
      this.containerForm.classList.remove('tw-hidden')
    })*/

    /*this.suppressButtonAdresses?.addEventListener('click', () => {
      document.querySelector('.js-delete-adresses').classList.remove('tw-hidden')
    })*/

    /*document.querySelector('.js-validate-suppression')?.addEventListener('click', () => {
      // delete all addresses
      this.removeMultipleAddresses()
    })*/

    this.querySelector('.js-button-csv')?.addEventListener('click', () => {
      this.infoPopup.classList.remove('tw-hidden')
    })

    document.querySelector('.js-close-csv-popup')?.addEventListener('click', () => {
      this.infoPopup.classList.add('tw-hidden')
    })

    document.querySelector('.js-cancel-suppression')?.addEventListener('click', () => {
      document.querySelector('.js-delete-adresses').classList.add('tw-hidden')
    })
    this.checkUIGiftBag()


    subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      // wait for opening drawer before performing actions
      setTimeout(() => {
        document.querySelector('.info__shipping')?.addEventListener('mouseenter', function () {
          document.querySelector('.modal__shipping__free').classList.remove('tw-hidden');
        });
        document.querySelector('.info__shipping')?.addEventListener('mouseleave', function () {
          document.querySelector('.modal__shipping__free').classList.add('tw-hidden');
        });
        this.checkUIGiftBag()
        // estimated delivery date
        this.updateDeliveryDate();

        // quick add associated products
        const quickAddButtons = this.querySelectorAll('.button-add-product-cart')
        if (quickAddButtons.length > 0) {
          quickAddButtons.forEach(button => {
            button.addEventListener('click', async () => {
              var productToAdd = [{
                id: button.dataset.id,
                quantity: 1
              }]
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: productToAdd })
              })
                  .then(response => response.json())
                  .then(async response => {
                    var cartData_product = response;
                    await publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: 'product-form',
                      productVariantId: button.dataset.id,
                      cartData: cartData_product
                    });
                    button.parentNode.remove()
                  })
            });
          })
        }
        var panel = document.querySelector('.associated-products-pannel')
        var list = document.querySelector('.associated-products-list')
        if (list.innerHTML.trim() === '') {
          panel.style.opacity = 0
          setTimeout(() => {
            panel.classList.add('tw-hidden')
          }, 200)
        } else {
          panel.classList.remove('tw-hidden')
          setTimeout(() => {
            panel.style.opacity = 1
          }, 100)
        }

        /*if (e.source === "cart-items" && e.cartData.items.some(item => item.quantity <= 2)) {
          this.removeMultipleAddresses()
        }*/

        if (e.source === "product-form" && e.cartData?.quantity <= 2) {
          /*this.removeMultipleAddresses()*/
          this.querySelector('.js-toggle-layer-gift')?.addEventListener('click', () => this.toggleGiftLayer())
        }
        /*if (e.source != "product-form" && e.carData?.item_count <= 2) {
          this.removeMultipleAddresses()
        }*/

        if (e.source != "product-form") {
          this.querySelector('.js-toggle-layer-gift')?.addEventListener('click', () => this.toggleGiftLayer())
        }
        if (e.source == "product-form" && e.cartData.quantity < 3) {
          setTimeout(() => {
            const quantityInputs = document.querySelectorAll('.quantity__input');
            const quantities = Array.from(quantityInputs).map(input => parseInt(input.value, 10));

            this.maxItemCount = Math.max(...quantities);

            if (quantities.every(quantity => quantity === this.maxItemCount)) {
              this.renderForm(this.maxItemCount, true);
            } else {
              this.evenOutCartItems();
            }
          }, 1000)
        }

        if (e.source != "product-form" && e.cartData.items.some(item => item.quantity >= 5)) {
          this.maxItemCount = e?.cartData?.items.reduce((max, item) => item.quantity > max ? item.quantity : max, 0);
          if (e.cartData.items.every(item => item.quantity === Math.max(...e.cartData.items.map(o => o.quantity)))) {
            this.renderForm(this.maxItemCount, true)
          } else {
            this.evenOutCartItems()
          }
        }


        if (e.source === "product-form" && e.cartData.quantity >= 5) {
          fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                const everyProduct = cart.items.every(item => item.quantity === Math.max(...cart.items.map(o => o.quantity)))
                everyProduct ? this.renderForm(cart.items[0].quantity, true) : this.evenOutCartItems()
              })
              .then(() => {
                this.querySelector('.js-toggle-layer-gift')?.addEventListener('click', () => this.toggleGiftLayer())
              })
        }
      }, 300)
    });
  }

  connectedCallback() {
    /*document.addEventListener('click', (event) => {
      const addressElement = event.target.closest('.js-text-resume-address');
      if (addressElement) {
        addressElement.classList.toggle('before:-tw-rotate-45');
        addressElement.classList.toggle('before:tw-rotate-[135deg]');
        addressElement.classList.toggle('before:tw-translate-y-2');

        document.querySelector('.js-resume-addresses').classList.toggle('hide_addresses');
      }
    });*/

    const quantityInputs = document.querySelectorAll('.quantity__input');
    const quantities = Array.from(quantityInputs).map(input => parseInt(input.value, 10));

    this.maxItemCount = Math.max(...quantities);
    if (quantities.every(quantity => quantity === this.maxItemCount)) {} else {
      this.evenOutCartItems();
    }

    document.querySelector('.info__shipping')?.addEventListener('mouseenter', function () {
      document.querySelector('.modal__shipping__free').classList.remove('tw-hidden');
    });
    document.querySelector('.info__shipping')?.addEventListener('mouseleave', function () {
      document.querySelector('.modal__shipping__free').classList.add('tw-hidden');
    });

    this.updateDeliveryDate();
  }

  updateDeliveryDate() {
    // update estimated delivery date

    /*const simulatedDay = 6;
    const simulatedHour = 8;

    const isEnglish = window.location.href.includes('/en/');
    const now = new Date();
    now.setDate(now.getDate() + (simulatedDay - now.getDay()));
    now.setHours(simulatedHour);
    now.setMinutes(0); */


    const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
    const now = new Date();

    const currentHour = now.getHours();

    const weekdayMessageFrBefore = "Commandez avant 12h pour être livré demain !";
    const weekdayMessageEnBefore = "Order before 12 PM to be delivered tomorrow!";
    const weekendMessageFrBefore = (day, month) => `Recevez votre commande à partir du ${day} ${month}`;
    const weekendMessageEnBefore = (day, month) => `Receive your order starting from Tuesday, ${day} ${month}`;
    const weekdayMessageFrAfter = (day, month) => `Recevez votre commande à partir du ${day} ${month}`;
    const weekdayMessageEnAfter = (day, month) => `Receive your order starting from ${day} ${month}`;

    function getNextTuesday() {
      const dayInMillisecs = 24 * 60 * 60 * 1000;
      let daysToAdd = (9 - now.getDay()) % 7;
      let nextTuesday = new Date(now.getTime() + daysToAdd * dayInMillisecs);
      return {
        day: nextTuesday.getDate(),
        month: nextTuesday.toLocaleString(isEnglish ? 'en-US' : 'fr-FR', { month: 'long' })
      };
    }

    function getDayAfterTomorrow() {
      const dayInMillisecs = 24 * 60 * 60 * 1000;
      let dayAfterTomorrow = new Date(now.getTime() + 2 * dayInMillisecs);
      return {
        day: dayAfterTomorrow.getDate(),
        month: dayAfterTomorrow.toLocaleString(isEnglish ? 'en-US' : 'fr-FR', { month: 'long' })
      };
    }

    function displayMessage() {
      const currentDay = now.getDay();

      if (currentHour < 12) {
        if (currentDay >= 1 && currentDay <= 5) {
          return isEnglish ? weekdayMessageEnBefore : weekdayMessageFrBefore;
        } else {
          const { day, month } = getNextTuesday();
          return isEnglish ? weekendMessageEnBefore(day, month) : weekendMessageFrBefore(day, month);
        }
      } else {
        if (currentDay >= 1 && currentDay <= 3) {
          const { day, month } = getDayAfterTomorrow();
          return isEnglish ? weekdayMessageEnAfter(day, month) : weekdayMessageFrAfter(day, month);
        } else {
          const { day, month } = getNextTuesday();
          return isEnglish ? weekdayMessageEnAfter(day, month) : weekdayMessageFrAfter(day, month);
        }
      }
    }

    const dateTargets = document.querySelectorAll('.js-dynamic-date-shipping');

    if (dateTargets.length > 0) {
      const message = displayMessage();
      dateTargets.forEach((target) => {
        target.innerHTML = message;
      });
    }
  }

  async checkUIGiftBag() {
    await fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          cart.items.forEach(item => {
            if (item.id == '45736774566110' || item.id == '45716559560926' || item.id == '45716554547422' || item.id == '45716562870494') {
              this.querySelector('[data-giftbag="' + item.id + '"]')?.classList.add('hidden-gift-bag')
            }
          })
        })
  }

  async toggleGiftLayer() {
    const alreadyExistingGift = []
    document.querySelector('.drawer').scrollTop = 0
    if (!this.existingGiftLayer) {
      document.querySelector('.js-toggle-layer-gift').classList.toggle('active')
    } else {
      this.querySelector('.js-validate-gift-bags').removeAttribute('disabled')
    }
    document.querySelector('.js-layer-gift').classList.toggle('hidden-layer')

    await fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          cart.items.forEach(item => {
            if (item.id == '45736774566110' || item.id == '45716559560926' || item.id == '45716554547422' || item.id == '45716562870494') {
              alreadyExistingGift.push({ id: item.id, quantity: item.quantity })
            }
          })
        })
    // remove any existing gift message
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { gift_message: '', gift_signature: '' } })
    })
    document.querySelector('.js-close-mobile-layer')?.addEventListener('click', () => {
      document.querySelector('.js-layer-gift').classList.add('hidden-layer')
      document.querySelector('.js-toggle-layer-gift').classList.remove('active')
    })

    // select medium and small bags to even out qty
    const small_bag = document.querySelector('[data-id="45716554547422"]')
    const medium_bag = document.querySelector('[data-id="45716559560926"]')
    let max_bag_qty = 0
    if (small_bag || medium_bag) {
      max_bag_qty = Number(small_bag.dataset.max) + Number(medium_bag.dataset.max)
      alreadyExistingGift.forEach(el => {
        if (parseInt(el.id) == '45716554547422' || parseInt(el.id) == '45716559560926') {
          max_bag_qty -= el.quantity
        }
      });
      small_bag.setAttribute('max', max_bag_qty)
      medium_bag.setAttribute('max', max_bag_qty)
    }

    if (alreadyExistingGift.length > 0) {
      alreadyExistingGift.forEach(item => {
        if (parseInt(item.id) != '45716554547422' && parseInt(item.id) != '45716559560926') {
          const el = document.querySelector(`[data-id="${item.id}"]`)
          el.max = el.max - item.quantity
        }
      })
    }

    this.bagsSelection = this.querySelectorAll('.js-giftbag-quantity')
    this.minusBags = this.querySelectorAll('.js-giftbag-minus')
    this.plusBags = this.querySelectorAll('.js-giftbag-plus')
    const arrayBags = new Array(this.bagsSelection.length).fill(0)

    function updateInputs(changedInput, otherInput, bagsSelection) {
      let value1 = parseInt(changedInput.value) || 0;
      let value2 = parseInt(otherInput.value) || 0;
      const arr = Array.prototype.slice.call(bagsSelection);
      const dataToUpdate = (element) => element == otherInput;
      const indexArray = arr.findIndex(dataToUpdate)

      if (value1 + value2 > max_bag_qty) {
        otherInput.value = max_bag_qty - changedInput.value
        arrayBags[indexArray] = max_bag_qty - changedInput.value
      }
    }

    function switchMediumSmall(input, bagsSelection) {
      if (input.dataset.id === '45716554547422') {
        updateInputs(input, medium_bag, bagsSelection)
      } else if (input.dataset.id === '45716559560926') {
        updateInputs(input, small_bag, bagsSelection)
      }
    }

    for (let i = 0; i < this.bagsSelection.length; i++) {
      const input = this.bagsSelection[i];
      const plus = this.plusBags[i];
      const minus = this.minusBags[i];

      input.addEventListener('input', (e) => {
        arrayBags[i] = Number(e.target.value)
        switchMediumSmall(input, this.bagsSelection)
      })
      plus.addEventListener('click', (e) => {
        arrayBags[i] = Number(input.value)
        switchMediumSmall(input, this.bagsSelection)
      })
      minus.addEventListener('click', (e) => {
        arrayBags[i] = Number(input.value)
        switchMediumSmall(input, this.bagsSelection)
      })
    }

    this.querySelector('.js-validate-gift-bags').addEventListener('click', async () => {
      this.querySelector('.js-validate-gift-bags').setAttribute('disabled', 'disabled')
      const giftMessage = this.querySelector('.js-gift-message').value
      const signature = this.querySelector('.js-signature-gift').value

      // not based on localstorage only push it once to attributes on click
      if (giftMessage !== '' && signature !== '') {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { gift_message: giftMessage ?? '', gift_signature: signature ?? '' } })
        })
      }

      let itemsToAdd = []
      this.bagsSelection.forEach((input, i) => {
        itemsToAdd.push({
          id: input.dataset.id,
          quantity: arrayBags[i]
        })
      })

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      })
          .then(response => response.json())
          .then(async response => {
            this.bagsSelection.forEach(async (input, j) => {
              if (arrayBags[j] > 0) {
                const cartData = response;
                await publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: input.dataset.id,
                  cartData: cartData,
                });
                this.checkUIGiftBag()
              }
            })
          })

      // execute things after bags added to cart
      this.existingGiftLayer = true
      document.querySelector('.js-layer-gift').classList.add('hidden-layer')
      document.querySelector('.js-edit-gift-layer').classList.remove('tw-hidden')
      this.bagsSelection.forEach(input => input.value = 0)
      this.querySelector('.js-validate-gift-bags').setAttribute('disabled', 'false')
    })
  }

  async updateCartAttributes(nameAttribute, arrayAdress, jsonAdress) {
    var headers = new Headers({ 'Content-Type': 'application/json' });
    const arrayLabel = ['Nom', 'Prénom', 'Adresse', 'Adresse ligne 2', 'Code Postal', 'Ville', 'Téléphone', 'ISO (pays)', 'Message cadeau']
    if (arrayAdress === '') {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ attributes: jsonAdress })
      })
    } else if (jsonAdress != null) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ attributes: jsonAdress })
      })
          .catch(error => console.error('Error:', error))
          .then(response => response.json())
    } else {
      const objectAdress = {}
      arrayLabel.forEach((label, i) => {
        objectAdress[label] = arrayAdress[i] ?? ''
      })

      fetch('/cart/update.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ attributes: { [nameAttribute]: objectAdress } })
      })
          .catch(error => console.error('Error:', error))
          .then(response => response.json())
    }
  }

  evenOutCartItems() {
    this.querySelector('.js-button-toggle-multi-address')?.addEventListener('click', () => {
      const existingBlock = document.querySelector('.js-container-display-address')
      existingBlock.classList.add('warning')
    })
  }

  /*async removeMultipleAddresses() {
    let adresseJson = {};  // Initialise un objet vide

    for (let i = 0; i < this.maxItemCount; i++) {
      adresseJson[`Adresse_${i + 1}`] = "";
    }

    document.querySelector('.js-toggle-layer-gift').classList.remove('tw-hidden')

    await this.updateCartAttributes('', '', adresseJson);

    // remove all addresses
    this.querySelector('.js-resume-addresses').innerHTML = ''

    const existingBlock = document.querySelectorAll('.js-multiple-addresses input')
    existingBlock.forEach(block => block.value = '')
    this.containerForm.classList.add('tw-hidden')
    document.querySelector('.js-delete-adresses').classList.add('tw-hidden')
    this.querySelector('.js-resume-addresses').classList.add('tw-hidden')
    this.querySelector('.js-text-resume-address').classList.add('tw-hidden')
    document.querySelector('.js-modify-addresses').classList.add('tw-hidden')
    this.querySelector('.js-container-display-address')?.classList.remove('tw-hidden')
    this.querySelector('.js-button-toggle-multi-address')?.classList.remove('active')
    this.state = false
    this.indexAddress = 0;
    this.maxIndexAddress = 0;
    this.translateX = 0;
    this.alreadyValidated = false;
    this.querySelector('.js-button-validate-address').setAttribute('disabled', 'disabled')
  }*/

  bulletPointAddress(index) {
    this.listButtons = this.querySelectorAll('.js-list-buttons button')
    this.listButtons.forEach(button => button.classList.remove('active'))
    this.listButtons[index].classList.add('active')
  }

  bulletButtonForm() {
    this.maxIndexAddress = this.indexAddress
    this.listButtons = this.querySelectorAll('.js-list-buttons button')
    this.listButtons.forEach((button, index) => {
      if (index <= this.indexAddress) {
        button.addEventListener('click', () => {
          this.indexAddress = index
          this.translateX = this.widthAddresses * this.indexAddress
          this.querySelector('.js-dynamic-render-form').style.transform = `translateX(-${this.translateX}px)`
          this.querySelector('.js-current-index-address').innerHTML = this.indexAddress + 1
          this.bulletPointAddress(this.indexAddress)
          if (this.indexAddress < this.maxIndexAddress) {
            this.querySelector('.js-button-validate-address').removeAttribute('disabled')
          } else {
            this.querySelector('.js-button-validate-address').setAttribute('disabled', 'disabled')
            this.checkNextFieldForm(this.indexAddress)
          }

          if (this.maxItemCount === (this.indexAddress + 1)) {
            this.querySelector('.js-hide-on-end').classList.add('tw-hidden')
          } else {
            this.querySelector('.js-hide-on-end').classList.remove('tw-hidden')
          }
        })
      }
    })
  }

  updateQuantityBulletPoint(total) {
    this.listButtons = this.querySelectorAll('.js-list-buttons li')
    if (this.listButtons) {
      if (this.listButtons.length > total) {
        for (let i = total; i < this.listButtons.length; i++) {
          this.listButtons[i].remove()
        }
      } else {
        const btn = `
          <li><button type="button" class="tw-w-3 tw-h-3 tw-rounded-full tw-bg-gray-300 tw-transition-colors tw-duration-500"></button></li>
        `
        const diff = total - this.listButtons.length
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            if (this.listButtons.length == 0) {
              this.querySelector('.js-list-buttons').insertAdjacentHTML('beforeend', btn)
              if (i == 0) {
                this.querySelector('.js-list-buttons li:first-of-type button').classList.add('active')
              }
            } else {
              this.listButtons[this.listButtons.length - 1].insertAdjacentHTML('afterend', btn)
            }
          }
        }
      }
    }
  }

  async checkFieldForm(index, isCSV = false) {
    this.block = document.querySelector(`.js-multiple-addresses-${index + 1}`)
    this.inputs = this.block.querySelectorAll('input')
    const arrayAdress = new Array(this.inputs.length - 1).fill('')
    let arrayCheck = []
    if (this.inputs.length > 0) {
      this.inputs.forEach((input, i) => {
        if (i === 3 || i == 8) {
          arrayAdress[i] = input.value ?? ''
          return
        }
        if (input.value === '') {
          input.style.borderColor = '#cc0303'
          input.addEventListener('input', () => input.style.borderColor = '')
          arrayCheck.push(false)
        } else {
          arrayCheck.push(true)
          arrayAdress[i] = input.value
        }
      })
    }
    if (arrayCheck.every(trueOrFalse => trueOrFalse === true)) {
      //localStorage.setItem(`_fauchon_multi_adresses_${index + 1}`, JSON.stringify(arrayAdress))
      if (!isCSV) {
        await this.updateCartAttributes(`Adresse_${index + 1}`, arrayAdress)
      }

      if (document.querySelectorAll('.js-multiple-addresses').length >= 5) {
        document.querySelector('.js-toggle-layer-gift').classList.add('tw-hidden')
      }
    }

    return arrayCheck.every(trueOrFalse => trueOrFalse === true)
  }

  checkNextFieldForm(index) {
    this.element = this.querySelector(`.js-multiple-addresses-${index + 1}`)
    if (this.element) {
      this.elementInputs = this.element.querySelectorAll('input')
      this.arrayValid = new Array(this.elementInputs.length - 1).fill(false)
      if (this.elementInputs.length > 0) {
        this.elementInputs.forEach((input, i) => {
          if (i === 3 || i == 8) {
            this.arrayValid[i] = true
          } else if (input.value === '') {
            this.arrayValid[i] = false
          } else {
            this.arrayValid[i] = true
          }
        })
      }

      if (this.arrayValid.every(value => value === true)) {
        this.querySelector('.js-button-validate-address').removeAttribute('disabled')
      } else {
        this.querySelector('.js-button-validate-address').setAttribute('disabled', 'disabled')
      }
    }
  }

  checkFilled(removeDisabled) {
    this.element = this.querySelector(`.js-multiple-addresses-${this.indexAddress + 1}`)
    this.elementInputs = this.element.querySelectorAll('input')
    this.arrayValid = new Array(this.elementInputs.length).fill(false)

    if (this.elementInputs.length > 0) {
      this.elementInputs.forEach((input, index) => {
        if (index === 3 || index == 8) {
          this.arrayValid[index] = true
        }
        input.addEventListener('input', () => {
          if (index === 3 || index == 8) {
            this.arrayValid[index] = true
          } else {
            this.arrayValid[index] = input.value !== ''
          }
          if (this.arrayValid.every(value => value === true)) {
            this.querySelector('.js-button-validate-address').removeAttribute('disabled')
          }
        })
      })
      if (removeDisabled) {
        this.querySelector('.js-button-validate-address').removeAttribute('disabled')
      }
    }
  }

  renderResumeAddresses(itemCount, attributes = {}) {
    const arrayForm = []
    for (let i = 0; i < itemCount; i++) {
      const existingBlock = this.querySelectorAll(`.js-multiple-addresses-${i + 1} input`)
      const arrayAdress = []
      existingBlock.forEach(input => {
        arrayAdress.push(input.value)
      })
      //localStorage.setItem(`_fauchon_multi_adresses_${i + 1}`, JSON.stringify(arrayAdress))
      arrayForm.push(arrayAdress)
    }

    this.buttonsModifyContainer.classList.remove('tw-hidden')

    this.querySelector('.js-resume-addresses').innerHTML = ''
    this.querySelector('.js-container-display-address').classList.add('tw-hidden')
    this.querySelector('.js-resume-addresses').classList.remove('tw-hidden')
    this.querySelector('.js-nb-address-resume').innerHTML = itemCount
    this.querySelector('.js-text-resume-address').classList.remove('tw-hidden')
    arrayForm.forEach((address, index) => {
      const resumeBlock = `
        <li ${(index + 1) !== itemCount && 'style="padding-bottom: 16px;"'} class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-font-sans tw-text-t-desc tw-m-4 ${(index + 1) !== itemCount && 'tw-border-b-[1px] tw-border-gray-300 tw-mb-0'}">
          <p class="tw-text-t-label tw-text-gray-400">${address[0]} ${address[1]}</p>
          <div style="width:170px;" class="tw-flex tw-flex-col tw-items-start">
            <p class="tw-text-t-label tw-text-gray-400">${address[2]}</p>
            <p class="tw-text-t-label tw-text-gray-400">${address[4]} ${address[5]}</p>
          </div>
        </li>
      `
      this.querySelector('.js-resume-addresses').insertAdjacentHTML('beforeend', resumeBlock)
    })
  }

  transformToJSON(obj) {
    for (let key in obj) {
      let value = obj[key];

      if (typeof value === 'string') {
        value = value.replace(/\"=>/g, '":').replace(/=>/g, ':').replace(/'/g, '"');

        if (!value.startsWith('{') || !value.endsWith('}')) {
          value = `{${value}}`;
        }

        try {
          obj[key] = JSON.parse(value);
        } catch (e) {
          console.error(`Erreur de parsing JSON pour ${key}:`, e);
        }
      }
    }

    return obj;
  }

  renderForm(itemCount, addMode = false, attributes = {}) {
    attributes = this.transformToJSON(attributes)

    const countExisting = this.querySelectorAll('.js-multiple-addresses').length
    let diff = countExisting - itemCount

    // change number of addresses
    this.totalQuantity = itemCount
    this.querySelectorAll('.js-total-quantiy').forEach(el => el.innerHTML = itemCount)

    // inside popup multi address
    this.buttonToggleMultiAddress = this.querySelector('.js-button-toggle-multi-address')

    this.buttonsCancelMultiAddress.forEach(button => {
      button.addEventListener('click', () => {
        this.state = false
        this.containerForm.classList.add('tw-hidden')
        button.classList.remove('active')
        this.buttonToggleMultiAddress.classList.remove('active')
      })
    })
    // close & open multi address
    if (this.state === true) {
      this.buttonToggleMultiAddress.classList.add('active')
      this.containerForm.classList.remove('tw-hidden')
    }
    this.buttonToggleMultiAddress?.addEventListener('click', () => {
      const quantityInputs = document.querySelectorAll('.quantity__input');
      const quantities = Array.from(quantityInputs).map(input => parseInt(input.value, 10));

      this.maxItemCount = Math.max(...quantities);

      if (quantities.every(quantity => quantity === this.maxItemCount)) {
        this.containerForm.classList.remove('tw-hidden')
        this.buttonsCancelMultiAddress.forEach(button => button.classList.add('active'))
      } else {
        this.containerForm.classList.add('tw-hidden')
        this.buttonToggleMultiAddress.classList.remove('active')
        const existingBlock = document.querySelector('.js-container-display-address')
        existingBlock.classList.add('warning')
      }
      /*this.state = !this.state*/
      /*if (this.state) {
        this.containerForm.classList.remove('tw-hidden')
        this.buttonsCancelMultiAddress.forEach(button => button.classList.add('active'))
      } else {
        this.containerForm.classList.add('tw-hidden')
      }
      this.buttonToggleMultiAddress.classList.toggle('active')*/
    })

    // render form multi address
    if ((diff > 0 && addMode == false) || (itemCount === 1 && countExisting === 0)) {
      for (let i = 0; i < itemCount; i++) {
        const existingBlock = this.querySelector(`.js-multiple-addresses-${i + 1} .js-address-total`)
        existingBlock.innerHTML = itemCount
      }
      if (itemCount == 1) {
        this.containerForm.classList.add('tw-hidden')
      } else {
        for (let i = 0; i < diff; i++) {
          const existingBlock = document.querySelector(`.js-multiple-addresses-${itemCount + i + 1}`)
          existingBlock?.remove()
        }
      }
      // remove bullet point
      this.updateQuantityBulletPoint(itemCount)
      // si réduction du total article et que déjà rempli revient en arrière & supprime données locales
      if (this.indexAddress + 1 >= itemCount) {
        for (let i = this.indexAddress; i > itemCount; i--) {
          //localStorage.removeItem(`_fauchon_multi_adresses_${i + 1}`)
          this.updateCartAttributes(`Adresse_${i + 1}`, '')
        }
        const diff = (this.indexAddress + 1) - itemCount
        this.indexAddress = itemCount - 1
        this.translateX = this.translateX - (this.widthAddresses * diff)
        this.querySelector('.js-dynamic-render-form').style.transform = `translateX(-${this.translateX}px)`
        document.querySelector('.js-hide-on-end')?.classList.add('tw-hidden')
        this.querySelector('.js-current-index-address').innerHTML = this.indexAddress + 1
        this.bulletPointAddress(this.indexAddress)
        this.checkFilled(true)
        this.bulletButtonForm()
      }
    } else {
      const arrayForm = []
      const existingForm = []
      for (let i = 0; i < itemCount; i++) {
        const existingData = attributes[`Adresse_${i + 1}`]

        if (existingData && existingData[0] != '') {
          existingForm.push(existingData)
        }

        const formBlock = `
          <div class="tw-flex tw-flex-col tw-min-w-[49rem] tw-gap-3 tw-mb-10 js-multiple-addresses js-multiple-addresses-${i + 1}">
            <p class="tw-text-xl tw-mb-4"><strong class="tw-text-2xl">Adresse ${i + 1}</strong>/<span class="js-address-total">${itemCount}</span></p>
            <div class="tw-px-2 tw-flex tw-flex-col tw-gap-4">
              <div class="tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-w-full">
                <label class="tw-mb-1 tw-text-t-desc" for="name${i + 1}">Nom</label>
                <input ${existingForm[i] && 'value="' + existingForm[i]['Nom'] + '"'} aria-label="name livraison" id="name${i + 1}" type="text" class="tw-border-gray-300 tw-rounded-lg tw-p-3 tw-text-sm tw-w-full tw-border-[1px] tw-text-left" />
              </div>
              <div class="tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-w-full">
                <label class="tw-mb-1 tw-text-t-desc" for="surname${i + 1}">Prénom</label>
                <input ${existingForm[i] && 'value="' + existingForm[i]['Prénom'] + '"'} aria-label="surname livraison" id="surname${i + 1}" type="text" class="tw-border-gray-300 tw-rounded-lg tw-p-3 tw-text-sm tw-w-full tw-border-[1px] tw-text-left" />
              </div>
              <div class="tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-w-full">
                <label class="tw-mb-1 tw-text-t-desc" for="address${i + 1}">Adresse</label>
                <input ${existingForm[i] && 'value="' + existingForm[i]['Adresse'] + '"'} aria-label="address livraison" id="address${i + 1}" type="text" class="tw-border-gray-300 tw-rounded-lg tw-p-3 tw-text-sm tw-w-full tw-border-[1px] tw-text-left" />
              </div>
              <div class="tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-w-full">
                <label class="tw-mb-1 tw-text-t-desc" for="addressSub${i + 1}">Adresse ligne 2</label>
                <input ${existingForm[i] && 'value="' + (existingForm[i]['Adresse ligne 2'] ?? '') + '"'} aria-label="addressSub livraison" id="addressSub${i + 1}" type="text" class="tw-border-gray-300 tw-rounded-lg tw-p-3 tw-text-sm tw-w-full tw-border-[1px] tw-text-left" />
              </div>
              <div class="tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-w-full">
                <label class="tw-mb-1 tw-text-t-desc" for="postalcode${i + 1}">Code Postal</label>
                <input ${existingForm[i] && 'value="' + existingForm[i]['Code Postal'] + '"'} aria-label="postalcode livraison" id="postalcode${i + 1}" type="text" class="tw-border-gray-300 tw-rounded-lg tw-p-3 tw-text-sm tw-w-full tw-border-[1px] tw-text-left" />
              </div>
              <div class="tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-w-full">
                <label class="tw-mb-1 tw-text-t-desc" for="city${i + 1}">Ville</label>
                <input ${existingForm[i] && 'value="' + existingForm[i]['Ville'] + '"'} aria-label="city livraison" id="city${i + 1}" type="text" class="tw-border-gray-300 tw-rounded-lg tw-p-3 tw-text-sm tw-w-full tw-border-[1px] tw-text-left" />
              </div>
              <div class="tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-w-full">
                <label class="tw-mb-1 tw-text-t-desc" for="phone${i + 1}">Téléphone</label>
                <input ${existingForm[i] && 'value="' + existingForm[i]['Téléphone'] + '"'} aria-label="phone livraison" id="phone${i + 1}" type="text" class="tw-border-gray-300 tw-rounded-lg tw-p-3 tw-text-sm tw-w-full tw-border-[1px] tw-text-left" />
              </div>
              <div class="tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-w-full">
                <label class="tw-mb-1 tw-text-t-desc" for="countryiso${i + 1}">ISO (pays)</label>
                <input ${existingForm[i] && 'value="' + existingForm[i]['ISO (pays)'] + '"'} aria-label="countryiso livraison" id="countryiso${i + 1}" type="text" class="tw-border-gray-300 tw-rounded-lg tw-p-3 tw-text-sm tw-w-full tw-border-[1px] tw-text-left" />
              </div>
              <div class="tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-w-full">
                <label class="tw-mb-1 tw-text-t-desc" for="giftMessage${i + 1}">Message cadeau</label>
                <input ${existingForm[i] && 'value="' + (existingForm[i]['Message cadeau'] ?? '') + '"'} aria-label="gift message livraison" id="giftMessage${i + 1}" type="text" class="tw-border-gray-300 tw-rounded-lg tw-p-3 tw-text-sm tw-w-full tw-border-[1px] tw-text-left" />
              </div>
            </div>
          </div>
        `
        arrayForm.push(formBlock)
      }

      if (existingForm.length > 0) {
        document.querySelector('.js-toggle-layer-gift').classList.add('tw-hidden')
      }

      arrayForm.forEach((form, i) => {
        const existing = this.querySelector(`.js-multiple-addresses-${i + 1}`)
        if (!existing) {
          this.querySelector('.js-dynamic-render-form').insertAdjacentHTML('beforeend', form)
        }
      })
      // add bullet
      this.updateQuantityBulletPoint(itemCount)
      // update total address
      for (let i = 0; i < itemCount; i++) {
        const existingBlock = this.querySelector(`.js-multiple-addresses-${i + 1} .js-address-total`)
        existingBlock.innerHTML = itemCount
      }

      // check if filled fields listeners
      this.checkFilled()

      if (existingForm.length > 0 && existingForm[0] !== null) {
        this.maxIndexAddress = existingForm.length
        if (this.indexAddress < this.maxIndexAddress) {
          this.querySelector('.js-button-validate-address').removeAttribute('disabled')
        }

        // if existing data == max item count display resume addresses
        if (existingForm.length === itemCount) {
          this.querySelector('.js-container-display-address').classList.add('tw-hidden')
          this.querySelector('.js-modify-addresses').classList.remove('tw-hidden')
          this.querySelector('.js-modify-button')?.addEventListener('click', () => {
            this.containerForm.classList.remove('tw-hidden')
          })
          this.querySelector('.js-suppress-button')?.addEventListener('click', () => {
            document.querySelector('.js-delete-adresses').classList.remove('tw-hidden')
          })
          this.renderResumeAddresses(this.maxIndexAddress, attributes)
        }
      }

      if (addMode && !this.listenerButtonValidate) {
        this.listenerButtonValidate = true
        this.querySelector('.js-button-validate-address').addEventListener('click', () => {
          if (this.checkFieldForm(this.indexAddress)) {
            this.translateX = this.widthAddresses * (this.indexAddress + 1)

            if (this.indexAddress < this.maxItemCount - 1) {
              this.querySelector('.js-hide-on-end')?.classList.remove('tw-hidden')
              this.querySelector('.js-dynamic-render-form').style.transform = `translateX(-${this.translateX}px)`
              this.indexAddress++
              if (this.indexAddress === (this.maxItemCount - 1)) {
                this.querySelector('.js-hide-on-end').classList.add('tw-hidden')
              }
              this.querySelector('.js-current-index-address').innerHTML = this.indexAddress + 1
              this.bulletPointAddress(this.indexAddress)
              if (this.maxIndexAddress === this.maxItemCount - 1) {
                this.querySelector('.js-button-validate-address').removeAttribute('disabled')
              } else {
                this.querySelector('.js-button-validate-address').setAttribute('disabled', 'disabled')
              }
              this.alreadyValidated ?
                  this.checkFilled(true) :
                  this.checkFilled()
              this.bulletButtonForm()
              this.checkNextFieldForm(this.indexAddress)
            } else {
              this.alreadyValidated = true
              this.querySelector('.js-dynamic-render-form').style.transform = `translateX(0)`
              this.indexAddress = 0
              this.containerForm.classList.add('tw-hidden')
              this.renderResumeAddresses(this.maxItemCount, attributes)
              this.bulletPointAddress(0)
              this.querySelector('.js-hide-on-end').classList.remove('tw-hidden')
              this.querySelector('.js-current-index-address').innerHTML = 1
              this.querySelector('.js-modify-addresses').classList.remove('tw-hidden')

              this.querySelector('.js-modify-button')?.addEventListener('click', () => {
                this.containerForm.classList.remove('tw-hidden')
              })
              this.querySelector('.js-suppress-button')?.addEventListener('click', () => {
                document.querySelector('.js-delete-adresses').classList.remove('tw-hidden')
              })
            }
          }
        })
      }
    }
  }

  async readCSV(event) {
    const file = event.target.files[0];
    const reader = new FileReader()

    reader.readAsText(file)
    reader.onload = () => {
      const data = reader.result.split('\r\n').map(s => s.split(','))
      let cartAttributes = {};
      data.forEach(async (row, index) => {
        const name = this.querySelector(`#name${index + 1}`)
        const surname = this.querySelector(`#surname${index + 1}`)
        const address = this.querySelector(`#address${index + 1}`)
        const addressSub = this.querySelector(`#addressSub${index + 1}`)
        const postalcode = this.querySelector(`#postalcode${index + 1}`)
        const city = this.querySelector(`#city${index + 1}`)
        const countryiso = this.querySelector(`#countryiso${index + 1}`)
        const phone = this.querySelector(`#phone${index + 1}`)
        const giftMessage = this.querySelector(`#giftMessage${index + 1}`)

        if (name) name.value = row[0]
        if (surname) surname.value = row[1]
        if (address) address.value = row[2]
        if (addressSub) addressSub.value = row[3]
        if (postalcode) postalcode.value = row[4]
        if (city) city.value = row[5]
        if (countryiso) countryiso.value = row[6]
        if (phone) phone.value = row[7]
        if (giftMessage) giftMessage.value = row[8]

        cartAttributes[`Adresse_${index + 1}`] = {
          "Nom": row[1],                // Nom
          "Prénom": row[0],              // Prénom
          "Adresse": row[2],             // Adresse
          "Adresse ligne 2": row[3] || "", // Adresse ligne 2, si pas de valeur, mettre chaîne vide
          "Code Postal": row[4],         // Code Postal
          "Ville": row[5],               // Ville
          "Téléphone": row[6],           // Téléphone
          "ISO (pays)": row[7],          // ISO (pays)
          "Message cadeau": row[8] || "" // Message cadeau, si pas de valeur, mettre chaîne vide
        };
      })
      this.updateCartAttributes('', ['test'], cartAttributes)

      this.querySelector('#csvfile').value = ''

      if (this.checkFieldForm(data.length - 1, true)) {
        this.translateX = this.widthAddresses * (data.length - 1)

        this.querySelector('.js-dynamic-render-form').style.transform = `translateX(-${this.translateX}px)`
        this.indexAddress = (data.length - 1)
        this.querySelector('.js-current-index-address').innerHTML = this.indexAddress + 1
        this.bulletPointAddress(this.indexAddress)
        this.checkFilled()
        this.bulletButtonForm()
        this.querySelector('.js-button-validate-address').removeAttribute('disabled')
        for (let i = 0; i < data.length - 1; i++) {
          this.checkFieldForm(i, true)
        }

        if (this.maxItemCount === (this.indexAddress + 1)) {
          this.querySelector('.js-hide-on-end').classList.add('tw-hidden')
        } else {
          this.querySelector('.js-hide-on-end').classList.remove('tw-hidden')
        }
      }
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    const formMultiAdresses = this.querySelector('.js-dynamic-render-form > div')

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.item_count > 0 && cart.items[0].quantity >= 5 && !formMultiAdresses) {
            const everyProduct = cart.items.every(item => item.quantity === Math.max(...cart.items.map(o => o.quantity)))
            everyProduct ? this.renderForm(cart.items[0].quantity, true, cart.attributes) : this.evenOutCartItems()
            this.maxItemCount = cart.items[0].quantity
          }
        });

    this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
    );

    document.body.classList.add('tw-overflow-hidden');
  }

  close() {
    // remove multi address display
    if (window.location.pathname != '/cart' && window.location.pathname != '/en/cart') {
      this.state = false
      this.containerForm.classList.add('tw-hidden')
      this.buttonsCancelMultiAddress.forEach(button => button.classList.remove('active'))
      this.buttonToggleMultiAddress?.classList?.remove('active')

      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('tw-overflow-hidden');
    } else {
      window.location.pathname = '/'
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
